import { useTranslation } from 'react-i18next';

import { CommandRequestStatus } from '../../../../../../../../generated/core-api/graphql-react-query';
import StyledTypography from './styles';

interface PublishedStatusProps {
  status?: CommandRequestStatus | undefined;
}

export default function CommandStatusTag(props: PublishedStatusProps) {
  const { status } = props;
  const { t } = useTranslation('command');

  return (
    <StyledTypography className={status ?? 'Ok'}>
      {t(`statuses.${status ?? 'Ok'}`)}
    </StyledTypography>

  );
}
